// Coffee Cup Product Functionality
console.log('Product Cup JS loaded');
console.log('Body classes:', document.body.className);

class CoffeeCupProduct {
    constructor() {
    console.log('CoffeeCupProduct initialized');
    
    // Live pricing cache
    this.productData = null;
    this.currentUnitPrice = 0;
    this.unitPricesByQuantity = {}; // Store unit prices for each quantity
    
    // State
    this.selectedSize = '2oz';
    this.selectedPrintType = 'Simple';
    this.selectedQuantity = 250;
      this.requireLids = false;
      this.lidColor = 'Black';
    this.isRushed = false;
    this.selectedProductionDays = 15;
    
    // Constants - Updated with accurate carton specifications
    this.UNITS_PER_CARTON = {
      '2oz': 1000,  // 430×350×490mm, 6.6kg
      '3oz': 1000,  // 370×300×440mm, 5.5kg
      '5oz': 800,   // 490×340×450mm, 5.5kg
      '8oz': 700,   // approximate cartons per 8oz
      '11oz': 630   // 496×333×558mm, 7.5kg
    };
    this.LID_PRICE_HIGH_QTY = 0.049; // 1000+ cups
    this.LID_PRICE_LOW_QTY = 0.059;  // <1000 cups
    this.productionDayOptions = Object.freeze([2, 3, 4, 5, 10, 15]);
    this.productionFeePercentages = Object.freeze({
      15: 0,
      10: 15,
      5: 30,
      4: 40,
      3: 50,
      2: 60
    });
    
    // Sizes that support Full Colour Print
    this.fullColourSizes = [];
    
    // Variant mapping for quantity-based pricing
    this.variantMapping = {
      "2oz_Simple": {
        "250": "50738736496922",
        "500": "50738736529690",
        "1000": "50738736562458",
        "2000": "50738736595226",
        "3000": "50738736627994",
        "4000": "50738736660762",
        "5000": "50738736693530"
      },
      "3oz_Simple": {
        "250": "50738736726298",
        "500": "50738736759066",
        "1000": "50738736791834",
        "2000": "50738736824602",
        "3000": "50738736857370",
        "4000": "50738736890138",
        "5000": "50738736922906"
      },
      "5oz_Simple": {
        "250": "50738736955674",
        "500": "50738736988442",
        "1000": "50738737021210",
        "2000": "50738737053978",
        "3000": "50738737086746",
        "4000": "50738737119514",
        "5000": "50738737152282"
      },
      "8oz_Simple": {
        "250": "51105843085594",
        "500": "51105843118362",
        "1000": "51105843151130",
        "2000": "51105843183898",
        "3000": "51105843216666",
        "4000": "51105843249434",
        "5000": "51105843282202"
      },
      "11oz_Simple": {
        "250": "50738737185050",
        "500": "50738737217818",
        "1000": "50738737250586",
        "2000": "50738737283354",
        "3000": "50738737316122",
        "4000": "50738737348890",
        "5000": "50738737381658"
      }
    };

    // Lid variant mapping - Updated with correct variant IDs from Shopify admin table
    this.lidVariantMapping = {
      "White": {
        "250": "50675484590362",
        "500": "50682897400090",
        "1000": "50682897432858",
        "2000": "50682897465626",
        "3000": "50682897498394",
        "4000": "50682897531162",
        "5000": "50682897563930",
        "10000": "50726870090010"
      },
      "Black": {
        "250": "50675484557594",
        "500": "50682897203482",
        "1000": "50682897236250",
        "2000": "50682897269018",
        "3000": "50682897301786",
        "4000": "50682897334554",
        "5000": "50682897367322",
        "10000": "50726870057242"
      }
    };
      
      this.init().catch(error => console.error('Initialization error:', error));
    }

    async init() {
    this.setupSizeSelector();
    this.setupPrintTypeSelector();
    this.setupLidsSelector();
    this.setupTurnaroundSelector();
    this.setupFormSubmission();
    this.setupFileUpload();
    this.setupShippingCalculator();
    this.setupDynamicDescription();
    this.setupTooltips();
    this.updatePrintTypeAvailability();
    await this.updatePricingTable();
    this.checkCartAddSuccess();
    this.preventAutoScroll();
  }

  async loadProductData() {
    if (this.productData) return this.productData;
    
    try {
      // First try to get from existing ProductJSON script
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (productScript) {
        this.productData = JSON.parse(productScript.textContent);
        console.log('Loaded product data from script:', this.productData.handle);
        return this.productData;
      }
      
      // Fallback: fetch from API using product handle from URL
      const pathParts = window.location.pathname.split('/');
      const handle = pathParts[pathParts.indexOf('products') + 1];
      
      if (handle) {
        const response = await fetch(`/products/${handle}.js`);
        this.productData = await response.json();
        console.log('Loaded product data from API:', this.productData.handle);
        return this.productData;
      }
      
      throw new Error('Could not determine product handle');
    } catch (error) {
      console.error('Failed to load product data:', error);
      return null;
    }
  }
  
  setupSizeSelector() {
    const sizeButtons = document.querySelectorAll('.size-btn');
    console.log('Setting up size selector, found buttons:', sizeButtons.length);
    
    sizeButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        console.log('Size button clicked:', btn.dataset.size);
        
        // Update selection
        sizeButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedSize = btn.dataset.size;
        console.log('Size selected:', this.selectedSize);
        
        this.updatePrintTypeAvailability();
        this.updatePricingTable().catch(console.error);
        this.updateDynamicDescription();
        this.updateMediaGalleryForSelectedVariant();
      });
    });
  }
  
  setupPrintTypeSelector() {
    const printButtons = document.querySelectorAll('.print-type-btn');
    console.log('[PrintType Debug] Setting up print type selector, found buttons:', printButtons.length);
    
    printButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('disabled')) {
          // Show popup if Full Colour is clicked while disabled
          if (btn.dataset.printType === 'FullColour') {
            this.showFullColourIncompatibilityPopup();
          }
          return;
        }
        
        // Update selection
        printButtons.forEach(b => b.classList.remove('selected'));
        btn.classList.add('selected');
        
        this.selectedPrintType = btn.dataset.printType;
        console.log('Print type selected:', this.selectedPrintType);
        
        // Auto-select appropriate quantity based on print type
        if (this.selectedPrintType === 'FullColour') {
          // Check if current quantity is available for Full Colour (must be 1000+)
          if (this.selectedQuantity < 1000) {
            this.selectedQuantity = 1000;
            console.log('Auto-selected 1000 quantity for Full Colour print');
          }
        } else if (this.selectedPrintType === 'Simple') {
          // When switching back to Simple Print, auto-select 250 if we're at a high quantity
          // This helps reset the state properly
          if (this.selectedQuantity >= 1000) {
            this.selectedQuantity = 250;
            console.log('Auto-selected 250 quantity for Simple print');
          }
        }
        
        this.updatePricingTable().catch(console.error);
        this.updateMediaGalleryForSelectedVariant();
      });
    });

    // Setup Full Colour incompatibility popup
    this.setupFullColourIncompatibilityPopup();
  }

  setupFullColourIncompatibilityPopup() {
    const fullColourBtn = document.getElementById('full-colour-print-btn');
    
    if (fullColourBtn) {
      // Show popup on hover when disabled
      fullColourBtn.addEventListener('mouseenter', () => {
        if (fullColourBtn.classList.contains('disabled')) {
          this.showFullColourIncompatibilityPopup();
        }
      });

      // Hide popup when mouse leaves
      fullColourBtn.addEventListener('mouseleave', () => {
        this.hideFullColourIncompatibilityPopup();
      });
    }
  }

  showFullColourIncompatibilityPopup() {
    // Remove any existing popup
    this.hideFullColourIncompatibilityPopup();
    
    // Get the button
    const fullColourBtn = document.getElementById('full-colour-print-btn');
    if (!fullColourBtn) return;
    
    // Get button position relative to viewport
    const rect = fullColourBtn.getBoundingClientRect();
    
    // Create new popup element
    const popup = document.createElement('div');
    popup.id = 'full-colour-incompatible-popup-new';
    popup.innerHTML = 'Full colour print is not available for ice cream cups';
    popup.style.cssText = `
      position: fixed !important;
      top: ${rect.top - 50}px !important;
      left: ${rect.left + rect.width / 2}px !important;
      transform: translateX(-50%) !important;
      background: #dc2626 !important;
      color: white !important;
      padding: 0.75rem 1rem !important;
      border-radius: 8px !important;
      font-size: 0.85rem !important;
      font-weight: 500 !important;
      white-space: nowrap !important;
      opacity: 1 !important;
      visibility: visible !important;
      z-index: 999999 !important;
      box-shadow: 0 8px 16px rgba(220, 38, 38, 0.3) !important;
      pointer-events: none !important;
    `;
    
    // Append to body to avoid opacity inheritance
    document.body.appendChild(popup);
    
    // Auto-hide after 3 seconds
    setTimeout(() => {
      this.hideFullColourIncompatibilityPopup();
    }, 3000);
  }
  
  hideFullColourIncompatibilityPopup() {
    const existingPopup = document.getElementById('full-colour-incompatible-popup-new');
    if (existingPopup) {
      existingPopup.remove();
    }
  }
  
  setupLidsSelector() {
    const lidsPills = document.querySelectorAll('.lids-pill');
    lidsPills.forEach(pill => {
      pill.addEventListener('click', () => {
        // Update selection
        lidsPills.forEach(p => p.classList.remove('selected'));
        pill.classList.add('selected');
        
        const lidsValue = pill.dataset.lids;
        this.requireLids = lidsValue !== 'no';
        this.lidColor = lidsValue === 'yes-white' ? 'White' : 'Black';
        
        console.log('Lids selected:', lidsValue, 'requireLids:', this.requireLids, 'lidColor:', this.lidColor);
        
      this.updatePricingTable().catch(console.error);
      });
    });
  }
  
  setupTurnaroundSelector() {
    const slider = document.getElementById('production-days-slider');
    const marks = document.querySelectorAll('.production-slider-mark');

    const syncSelection = () => {
      if (!slider) return;

      this.selectedProductionDays = this.getProductionDaysForSliderValue(slider.value);
      this.isRushed = this.getProductionFeePercent() > 0;
      console.log(
        'Production time selected:',
        this.selectedProductionDays,
        'business days',
        'fee:',
        `${this.getProductionFeePercent()}%`
      );

      this.syncProductionTimeUI();
      this.updatePricingTable().catch(console.error);
      this.updateShippingCalculator();
    };

    if (slider) {
      slider.addEventListener('input', syncSelection);
      slider.addEventListener('change', syncSelection);

      if (window.setupProductionSliderDemo) {
        window.setupProductionSliderDemo({ slider, onValueChange: syncSelection });
      }
    }

    marks.forEach(mark => {
      mark.addEventListener('click', () => {
        if (!slider) return;
        this.selectedProductionDays = Number(mark.dataset.days) || 15;
        slider.value = this.getSliderValueForProductionDays(this.selectedProductionDays);
        syncSelection();
      });
    });

    this.syncProductionTimeUI();
  }

  getSliderValueForProductionDays(days) {
    const index = this.productionDayOptions.indexOf(Number(days));
    return index === -1 ? this.productionDayOptions.length - 1 : index;
  }

  getProductionDaysForSliderValue(value) {
    return this.productionDayOptions[Math.round(Number(value))] ?? 15;
  }

  getProductionFeePercent(days = this.selectedProductionDays) {
    return this.productionFeePercentages[Number(days)] ?? 0;
  }

  getProductionFeeMultiplier() {
    return this.getProductionFeePercent() / 100;
  }

  getProductionTimeLabel(days = this.selectedProductionDays) {
    const dayCount = Number(days) || 15;
    if (dayCount === 15) {
      return 'Standard (15 business days)';
    }
    return `${dayCount} business day${dayCount === 1 ? '' : 's'}`;
  }

  getProductionFeeLabel(days = this.selectedProductionDays) {
    const feePercent = this.getProductionFeePercent(days);
    return feePercent > 0 ? `+${feePercent}% production fee` : 'No production fee';
  }

  getProductionTimePropertyValue() {
    const feePercent = this.getProductionFeePercent();
    return feePercent > 0
      ? `${this.getProductionTimeLabel()} (+${feePercent}% production fee)`
      : this.getProductionTimeLabel();
  }

  syncProductionTimeUI() {
    const slider = document.getElementById('production-days-slider');
    const daysValue = document.getElementById('production-days-value');
    const feeValue = document.getElementById('production-fee-value');
    const rushLabel = document.getElementById('summary-rush-label');
    const feePercent = this.getProductionFeePercent();

    if (daysValue) daysValue.textContent = this.getProductionTimeLabel();
    if (feeValue) feeValue.textContent = this.getProductionFeeLabel();
    if (rushLabel) rushLabel.textContent = feePercent > 0 ? `Production Fee (+${feePercent}%):` : 'Production Fee:';

    if (slider) {
      const progress = (Number(slider.value) / Number(slider.max || 1)) * 100;
      slider.style.setProperty('--production-progress', `${progress}%`);
    }

    document.querySelectorAll('.production-slider-mark').forEach(mark => {
      mark.classList.toggle('is-active', Number(mark.dataset.days) === Number(this.selectedProductionDays));
    });
  }

  setupShippingCalculator() {
    // Initialize the shipping calculator on page load
    this.updateShippingCalculator();
  }

  updateShippingCalculator() {
    const currentDate = new Date();
    const deliveryRangeEl = document.getElementById('delivery-range');
    const orderDateEl = document.getElementById('order-date');
    const shippedDateEl = document.getElementById('shipped-date');
    const doorstepDateEl = document.getElementById('doorstep-date');

    if (!deliveryRangeEl || !orderDateEl || !shippedDateEl || !doorstepDateEl) {
      console.log('Shipping calculator elements not found');
      return;
    }

    const productionDays = Number(this.selectedProductionDays) || 15;
    const minDeliveryDays = productionDays + 1;
    const maxDeliveryDays = productionDays + 3;

    // Calculate dates
    const orderDate = new Date(currentDate);
    const shippedDate = this.addBusinessDays(orderDate, productionDays);
    const doorstepDate = this.addBusinessDays(orderDate, maxDeliveryDays);
    const minDoorstepDate = this.addBusinessDays(orderDate, minDeliveryDays);

    // Format dates
    const formatDate = (date) => {
      const options = { month: 'short', day: 'numeric' };
      const suffix = this.getDateSuffix(date.getDate());
      return date.toLocaleDateString('en-US', options).replace(/\d+/, date.getDate() + suffix);
    };

    const productionTimeText = this.getProductionTimeLabel();
    
    if (minDeliveryDays === maxDeliveryDays) {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(doorstepDate)}`;
    } else {
      deliveryRangeEl.textContent = `${productionTimeText} ${formatDate(minDoorstepDate)} to ${formatDate(doorstepDate)}`;
    }

    // Update timeline dates
    orderDateEl.textContent = formatDate(orderDate);
    shippedDateEl.textContent = formatDate(shippedDate);
    doorstepDateEl.textContent = formatDate(doorstepDate);
  }

  addBusinessDays(startDate, days) {
    const result = new Date(startDate);
    let addedDays = 0;

    while (addedDays < days) {
      result.setDate(result.getDate() + 1);
      // Skip weekends (Saturday = 6, Sunday = 0)
      if (result.getDay() !== 0 && result.getDay() !== 6) {
        addedDays++;
      }
    }

    return result;
  }

  getDateSuffix(day) {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  setupDynamicDescription() {
    // Initialize with default size (2oz)
    this.updateDynamicDescription();
    
    // Setup accordion dropdown functionality (only one open at a time)
    this.setupAccordionBehavior('.dynamic-description'); // Desktop version
    this.setupAccordionBehavior('.dynamic-description-mobile'); // Mobile version
    
    // Auto-open the first tab (Description) on page load
    this.openDescriptionTab();
  }

  openDescriptionTab() {
    // Open description tab on desktop
    const desktopDescriptionTitle = document.querySelector('.dynamic-description .dropdown-title[data-target="description-content"]');
    const desktopDescriptionContent = document.getElementById('description-content');
    
    if (desktopDescriptionTitle && desktopDescriptionContent) {
      desktopDescriptionTitle.classList.add('active');
      desktopDescriptionContent.classList.add('active');
    }
    
    // Open description tab on mobile
    const mobileDescriptionTitle = document.querySelector('.dynamic-description-mobile .dropdown-title[data-target="description-content-mobile"]');
    const mobileDescriptionContent = document.getElementById('description-content-mobile');
    
    if (mobileDescriptionTitle && mobileDescriptionContent) {
      mobileDescriptionTitle.classList.add('active');
      mobileDescriptionContent.classList.add('active');
    }
  }

  setupAccordionBehavior(containerSelector) {
    console.log('Setting up accordion behavior for:', containerSelector);
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.log('Container not found:', containerSelector);
      return;
    }
    
    const dropdownTitles = container.querySelectorAll('.dropdown-title');
    console.log('Found dropdown titles:', dropdownTitles.length);
    
    dropdownTitles.forEach((title, index) => {
      console.log(`Styling dropdown title ${index}:`, title.textContent);
      // Force bold styling directly on the element
      title.style.fontWeight = '700';
      title.style.fontWeight = 'bold';
      title.style.setProperty('font-weight', '700', 'important');
      console.log('Applied styles to:', title.textContent, 'font-weight:', title.style.fontWeight);
      
      title.addEventListener('click', (e) => {
        const targetId = title.getAttribute('data-target');
        const content = document.getElementById(targetId);
        
        if (content) {
          const isCurrentlyActive = title.classList.contains('active');
          
          // Close all dropdowns in this container first
          dropdownTitles.forEach(otherTitle => {
            const otherTargetId = otherTitle.getAttribute('data-target');
            const otherContent = document.getElementById(otherTargetId);
            
            if (otherContent) {
              otherTitle.classList.remove('active');
              otherContent.classList.remove('active');
            }
          });
          
          // If this wasn't active, open it
          if (!isCurrentlyActive) {
            title.classList.add('active');
            content.classList.add('active');
          }
        }
      });
    });
  }

  updateDynamicDescription() {
    const descriptionData = this.getDescriptionData();
    
    // Update desktop version
    const descriptionContent = document.getElementById('description-content');
    const specificationContent = document.getElementById('specification-content');
    const dielinesContent = document.getElementById('dielines-content');
    const howItWorksContent = document.getElementById('how-it-works-content');
    
    // Update mobile version
    const descriptionContentMobile = document.getElementById('description-content-mobile');
    const specificationContentMobile = document.getElementById('specification-content-mobile');
    const dielinesContentMobile = document.getElementById('dielines-content-mobile');
    const howItWorksContentMobile = document.getElementById('how-it-works-content-mobile');
    
    if (descriptionData) {
      // Update desktop
      if (descriptionContent) {
        descriptionContent.innerHTML = descriptionData.description;
      }
      if (specificationContent) {
        specificationContent.innerHTML = descriptionData.specification;
      }
      if (dielinesContent) {
        dielinesContent.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContent && !howItWorksContent.hasAttribute('data-static-journey')) {
        howItWorksContent.innerHTML = descriptionData.howItWorks;
      }
      
      // Update mobile (same content)
      if (descriptionContentMobile) {
        descriptionContentMobile.innerHTML = descriptionData.description;
      }
      if (specificationContentMobile) {
        specificationContentMobile.innerHTML = descriptionData.specification;
      }
      if (dielinesContentMobile) {
        dielinesContentMobile.innerHTML = descriptionData.dielines;
      }
      if (howItWorksContentMobile && !howItWorksContentMobile.hasAttribute('data-static-journey')) {
        howItWorksContentMobile.innerHTML = descriptionData.howItWorks;
      }
    }
  }

  getDescriptionData() {
    const sizeDescriptions = {
      "2oz": {
        description: `
          <p>Our 2oz (60ml) Ice Cream Cups are perfect for small servings, samples, and tasting portions. Compact and fully brandable — ideal for ice cream parlours, events, and promotional tastings.</p>
          <p>Available with <strong>Simple printing only</strong> — your logo or design printed crisp and clean on a premium white background.</p>
          <p><strong>Note:</strong> Full colour printing is not available for ice cream cups.</p>
          <p><strong>Minimum order: 250 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">60ml (2oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
            <li><span class="spec-label">Product Type:</span> <span class="spec-value">Ice cream cup (no lids)</span></li>
            <li><span class="spec-label">Recyclable:</span> <span class="spec-value">Yes - PE lined recyclable</span></li>
            <li><span class="spec-label">Certification:</span> <span class="spec-value">Food safe, FSC certified</span></li>
            <li><span class="spec-label">Carton Dimensions:</span> <span class="spec-value">430mm × 350mm × 490mm</span></li>
            <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">6.6kg</span></li>
            <li><span class="spec-label">Qty/Carton:</span> <span class="spec-value">1,000 units</span></li>
          </ul>
        `,
        dielines: `
          <p>To ensure perfect print placement, download the dieline below and apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/2oz_Ice-Cream_Cup_Template_55d46f65-603f-4b75-984b-bef6bd3c12d7.pdf?v=1752802882" class="download-btn" download="2oz_Ice-Cream_Cup_Template.pdf" target="_blank">👉 Download 2oz Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and quantity, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom ice cream cups go into production — standard turnaround is 15 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      },
      "3oz": {
        description: `
          <p>Our 3oz (90ml) Ice Cream Cups are ideal for single scoops and kid-friendly portions. Perfect for ice cream shops, cafés, and events where portion control and branding matter.</p>
          <p>Available with <strong>Simple printing only</strong> — your logo or design printed crisp and clean on a premium white background.</p>
          <p><strong>Note:</strong> Full colour printing is not available for ice cream cups.</p>
          <p><strong>Minimum order: 250 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">90ml (3oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
            <li><span class="spec-label">Product Type:</span> <span class="spec-value">Ice cream cup (no lids)</span></li>
            <li><span class="spec-label">Recyclable:</span> <span class="spec-value">Yes - PE lined recyclable</span></li>
            <li><span class="spec-label">Certification:</span> <span class="spec-value">Food safe, FSC certified</span></li>
            <li><span class="spec-label">Carton Dimensions:</span> <span class="spec-value">370mm × 300mm × 440mm</span></li>
            <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">5.5kg</span></li>
            <li><span class="spec-label">Qty/Carton:</span> <span class="spec-value">1,000 units</span></li>
          </ul>
        `,
        dielines: `
          <p>To ensure perfect print placement, download the dieline below and apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/3oz_Ice-Cream_Cup_Template_0f35a9b0-ebe6-49bf-a8f5-78cfdd65ffdf.pdf?v=1752802882" class="download-btn" download="3oz_Ice-Cream_Cup_Template.pdf" target="_blank">👉 Download 3oz Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and quantity, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom ice cream cups go into production — standard turnaround is 15 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      },
      "5oz": {
        description: `
          <p>Our 5oz (150ml) Ice Cream Cups are perfect for standard single scoops and small sundaes. The most popular size for ice cream parlours, food trucks, and events requiring quality branded presentation.</p>
          <p>Available with <strong>Simple printing only</strong> — your logo or design printed crisp and clean on a premium white background.</p>
          <p><strong>Note:</strong> Full colour printing is not available for ice cream cups.</p>
          <p><strong>Minimum order: 250 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">150ml (5oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
            <li><span class="spec-label">Product Type:</span> <span class="spec-value">Ice cream cup (no lids)</span></li>
            <li><span class="spec-label">Recyclable:</span> <span class="spec-value">Yes - PE lined recyclable</span></li>
            <li><span class="spec-label">Certification:</span> <span class="spec-value">Food safe, FSC certified</span></li>
            <li><span class="spec-label">Carton Dimensions:</span> <span class="spec-value">490mm × 340mm × 450mm</span></li>
            <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">5.5kg</span></li>
            <li><span class="spec-label">Qty/Carton:</span> <span class="spec-value">800 units</span></li>
          </ul>
        `,
        dielines: `
          <p>To ensure perfect print placement, download the dieline below and apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/5oz_Ice-Cream_Cup_Template_9723ae38-307e-42fe-966b-e4f4283d9d8b.pdf?v=1752802883" class="download-btn" download="5oz_Ice-Cream_Cup_Template.pdf" target="_blank">👉 Download 5oz Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and quantity, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom ice cream cups go into production — standard turnaround is 15 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      },
      "11oz": {
        description: `
          <p>Our 11oz (325ml) Ice Cream Cups are designed for large servings, multiple scoops, and premium sundaes. Perfect for ice cream parlours, dessert shops, and events where generous portions and strong branding are essential.</p>
          <p>Available with <strong>Simple printing only</strong> — your logo or design printed crisp and clean on a premium white background.</p>
          <p><strong>Note:</strong> Full colour printing is not available for ice cream cups.</p>
          <p><strong>Minimum order: 250 units.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">325ml (11oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paperboard</span></li>
            <li><span class="spec-label">Coating:</span> <span class="spec-value">PE Food-grade inner lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple printing only</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units</span></li>
            <li><span class="spec-label">Product Type:</span> <span class="spec-value">Ice cream cup (no lids)</span></li>
            <li><span class="spec-label">Recyclable:</span> <span class="spec-value">Yes - PE lined recyclable</span></li>
            <li><span class="spec-label">Certification:</span> <span class="spec-value">Food safe, FSC certified</span></li>
            <li><span class="spec-label">Carton Dimensions:</span> <span class="spec-value">496mm × 333mm × 558mm</span></li>
            <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">7.5kg</span></li>
            <li><span class="spec-label">Qty/Carton:</span> <span class="spec-value">630 units</span></li>
          </ul>
        `,
        dielines: `
          <p>To ensure perfect print placement, download the dieline below and apply your design:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/11oz_Ice-Cream_Cup_Template.pdf?v=1752802882" class="download-btn" download="11oz_Ice-Cream_Cup_Template.pdf" target="_blank">👉 Download 11oz Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and quantity, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom ice cream cups go into production — standard turnaround is 15 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      },
      "4oz": {
        description: `
          <p>Our 4oz (110ml) Recyclable Ice Cream Containers are perfect for single-serve portions, gelato tastings, and sample sizes. Made from FSC-certified paper with PE food-grade lining — ideal for ice cream parlours, cafés, and events requiring durable, recyclable packaging.</p>
          <p><strong>Available in Simple or Full Colour printing:</strong></p>
          <p>• <strong>Simple:</strong> clean logos and text on premium white background (MOQ 250 units)<br>
          • <strong>Full Colour:</strong> vibrant, full-wrap designs with unlimited colors (MOQ 1,000 units)</p>
          <p><strong>Recyclable through standard paper recycling streams.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">110ml (4oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paper</span></li>
            <li><span class="spec-label">Lining:</span> <span class="spec-value">PE food-grade lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple or Full Colour</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units (Simple) / 1,000 units (Full Colour)</span></li>
            <li><span class="spec-label">Lid:</span> <span class="spec-value">PE lid available (recyclable)</span></li>
            <li><span class="spec-label">Recyclability:</span> <span class="spec-value">Standard paper recycling</span></li>
            <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">6.2kg</span></li>
          </ul>
        `,
        dielines: `
          <p>To ensure perfect print placement, download the dieline below and apply your design:</p>
          <a href="/pages/contact-us" class="download-btn">👉 Get in touch</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and quantity, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom ice cream containers go into production — standard turnaround is 15 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      },
      "8oz": {
        description: `
          <p>Our 8oz (240ml) Recyclable Ice Cream Containers are the perfect size for regular serves, takeaway portions, and retail ice cream. Made from FSC-certified paper with PE food-grade lining — ideal for busy ice cream shops and venues requiring durable, recyclable packaging.</p>
          <p><strong>Available in Simple or Full Colour printing:</strong></p>
          <p>• <strong>Simple:</strong> clean logos and text on premium white background (MOQ 250 units)<br>
          • <strong>Full Colour:</strong> vibrant, full-wrap designs with unlimited colors (MOQ 1,000 units)</p>
          <p><strong>Recyclable through standard paper recycling streams.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">240ml (8oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paper</span></li>
            <li><span class="spec-label">Lining:</span> <span class="spec-value">PE food-grade lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple or Full Colour</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units (Simple) / 1,000 units (Full Colour)</span></li>
            <li><span class="spec-label">Lid:</span> <span class="spec-value">PE lid available (recyclable)</span></li>
            <li><span class="spec-label">Recyclability:</span> <span class="spec-value">Standard paper recycling</span></li>
            <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">9.2kg</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the template to ensure perfect print placement:</p>
          <a href="https://cdn.shopify.com/s/files/1/0907/2433/5898/files/8oz_Ice-Cream_Cup_Template.pdf?v=1758779245" class="download-btn" download="8oz_Ice-Cream_Cup_Template.pdf" target="_blank">👉 Download 8oz Template</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom recyclable ice cream containers go into production — standard turnaround is 15 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      },
      "12oz": {
        description: `
          <p>Our 12oz (355ml) Recyclable Ice Cream Containers are perfect for generous serves, family portions, and premium ice cream experiences. Made from FSC-certified paper with PE food-grade lining — ideal for parlours, events, and food service requiring durable, recyclable packaging.</p>
          <p><strong>Available in Simple or Full Colour printing:</strong></p>
          <p>• <strong>Simple:</strong> clean logos and text on premium white background (MOQ 250 units)<br>
          • <strong>Full Colour:</strong> vibrant, full-wrap designs with unlimited colors (MOQ 1,000 units)</p>
          <p><strong>Recyclable through standard paper recycling streams.</strong></p>
        `,
        specification: `
          <ul>
            <li><span class="spec-label">Capacity:</span> <span class="spec-value">355ml (12oz)</span></li>
            <li><span class="spec-label">Material:</span> <span class="spec-value">FSC-certified paper</span></li>
            <li><span class="spec-label">Lining:</span> <span class="spec-value">PE food-grade lining</span></li>
            <li><span class="spec-label">Print Type:</span> <span class="spec-value">Simple or Full Colour</span></li>
            <li><span class="spec-label">MOQ:</span> <span class="spec-value">250 units (Simple) / 1,000 units (Full Colour)</span></li>
            <li><span class="spec-label">Lid:</span> <span class="spec-value">PE lid available (recyclable)</span></li>
            <li><span class="spec-label">Recyclability:</span> <span class="spec-value">Standard paper recycling</span></li>
            <li><span class="spec-label">Carton Weight:</span> <span class="spec-value">12.5kg</span></li>
          </ul>
        `,
        dielines: `
          <p>Download the template to ensure perfect print placement:</p>
          <a href="/pages/contact-us" class="download-btn">👉 Get in touch</a>
          <p style="margin-top: 1rem; font-size: 0.9rem; color: #64748b;">Need help with templates or setting up your artwork? Get in touch — we're here to make it easy.</p>
        `,
        howItWorks: `
          <div class="process-timeline">
            <div class="process-step">
              <div class="process-number">1</div>
              <div class="process-text"><strong>Confirm Your Order</strong><br>Choose your size and print type, upload artwork, and finalise your order details.</div>
            </div>
            <div class="process-step">
              <div class="process-number">2</div>
              <div class="process-text"><strong>Approve Your Artwork</strong><br>We'll send you a digital mockup for review. Nothing goes to print without your sign-off.</div>
            </div>
            <div class="process-step">
              <div class="process-number">3</div>
              <div class="process-text"><strong>Production Begins</strong><br>Once approved, your custom recyclable ice cream containers go into production — standard turnaround is 15 business days.</div>
            </div>
            <div class="process-step">
              <div class="process-number">4</div>
              <div class="process-text"><strong>Dispatched & Delivered</strong><br>Your order is packed, shipped via tracked courier, and on its way. We'll email you tracking info once it's out the door.</div>
            </div>
          </div>
        `
      }
    };
    
    return sizeDescriptions[this.selectedSize] || sizeDescriptions["2oz"];
  }
  
  setupTooltips() {
    const tooltipIcons = document.querySelectorAll('.tooltip-icon[data-tooltip]');
    
    tooltipIcons.forEach(icon => {
      let tooltip = null;
      
      const showTooltip = (e) => {
        // Remove any existing tooltips
        document.querySelectorAll('.tooltip-popup').forEach(t => t.remove());
        
        const tooltipText = icon.getAttribute('data-tooltip');
        if (!tooltipText) return;
        
        // Create tooltip element
        tooltip = document.createElement('div');
        tooltip.className = 'tooltip-popup';
        tooltip.innerHTML = tooltipText;
        
        // Style the tooltip
        Object.assign(tooltip.style, {
          position: 'absolute',
          background: '#000000',
          color: '#ffffff',
          padding: '12px 16px',
          borderRadius: '6px',
          fontSize: '14px',
          fontWeight: '400',
          lineHeight: '1.4',
          maxWidth: '300px',
          width: 'auto',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          zIndex: '9999',
          opacity: '0',
          visibility: 'hidden',
          transition: 'all 0.2s ease',
          pointerEvents: 'none'
        });
        
        // Add to DOM - append to the icon's parent container for better positioning
        const container = icon.closest('.form__label') || icon.parentElement;
        container.style.position = 'relative';
        container.appendChild(tooltip);
        
        // Position tooltip relative to icon
        const iconRect = icon.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        
        // Get tooltip dimensions after adding to DOM
        tooltip.style.visibility = 'visible';
        tooltip.style.opacity = '0';
        const tooltipRect = tooltip.getBoundingClientRect();
        tooltip.style.visibility = 'hidden';
        
        // Calculate position relative to container
        const iconLeft = iconRect.left - containerRect.left;
        const iconTop = iconRect.top - containerRect.top;
        
        // Position above the icon, centered horizontally
        let left = iconLeft + (iconRect.width / 2) - (tooltipRect.width / 2);
        let top = iconTop - tooltipRect.height - 8;
        
        // Keep tooltip within viewport
        const viewportWidth = window.innerWidth;
        const tooltipLeftInViewport = containerRect.left + left;
        const tooltipRightInViewport = tooltipLeftInViewport + tooltipRect.width;
        
        // Adjust horizontal position if going off screen
        if (tooltipLeftInViewport < 10) {
          left = 10 - containerRect.left;
        } else if (tooltipRightInViewport > viewportWidth - 10) {
          left = (viewportWidth - 10 - containerRect.left) - tooltipRect.width;
        }
        
        // If no room above, show below
        if (containerRect.top + top < 10) {
          top = iconTop + iconRect.height + 8;
        }
        
        tooltip.style.left = left + 'px';
        tooltip.style.top = top + 'px';
        
        // Show tooltip
        requestAnimationFrame(() => {
          tooltip.style.opacity = '1';
          tooltip.style.visibility = 'visible';
        });
      };
      
      const hideTooltip = () => {
        if (tooltip) {
          tooltip.style.opacity = '0';
          tooltip.style.visibility = 'hidden';
          setTimeout(() => {
            if (tooltip && tooltip.parentNode) {
              tooltip.parentNode.removeChild(tooltip);
            }
            tooltip = null;
          }, 200);
        }
      };
      
      // Add event listeners
      icon.addEventListener('mouseenter', showTooltip);
      icon.addEventListener('mouseleave', hideTooltip);
      icon.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    });
    
         // Clean up tooltips on page interactions
     document.addEventListener('scroll', () => {
       document.querySelectorAll('.tooltip-popup').forEach(t => {
         if (t.parentNode) t.parentNode.removeChild(t);
       });
     });
     
     document.addEventListener('click', (e) => {
       if (!e.target.closest('.tooltip-icon')) {
         document.querySelectorAll('.tooltip-popup').forEach(t => {
           if (t.parentNode) t.parentNode.removeChild(t);
         });
       }
          });
  }
  
  setupFormSubmission() {
    const customButton = document.getElementById('custom-add-to-cart-btn');
    if (customButton) {
      customButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.addToCart();
      });
    }
  }
  
  setupFileUpload() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    if (!fileInput) {
      console.log('File upload input not found');
      return;
    }

    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileInfo = document.querySelector('div[id^="fileInfo-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');
    const removeButton = document.querySelector('button[id^="removeFile-"]');

    // Click handler for upload area
    if (uploadArea) {
      uploadArea.addEventListener('click', () => {
        fileInput.click();
      });

      // Drag and drop handlers
      uploadArea.addEventListener('dragover', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#3b82f6';
        uploadArea.style.backgroundColor = '#eff6ff';
      });

      uploadArea.addEventListener('dragleave', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
      });

      uploadArea.addEventListener('drop', (e) => {
        e.preventDefault();
        uploadArea.style.borderColor = '#cbd5e1';
        uploadArea.style.backgroundColor = '#f8fafc';
        
        const files = e.dataTransfer.files;
        if (files.length) {
          fileInput.files = files;
          this.handleFileSelection(files[0]);
        }
      });
    }

    // File selection handler
    fileInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
      this.handleFileSelection(file);
    });

    // Remove file handler
    if (removeButton) {
      removeButton.addEventListener('click', (e) => {
        e.stopPropagation();
        this.clearFileSelection();
      });
    }
  }

  handleFileSelection(file) {
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');
    const fileName = document.querySelector('div[id^="fileName-"]');
    const fileSize = document.querySelector('div[id^="fileSize-"]');

    if (!file) {
      this.clearFileSelection();
      return;
    }

    // Validate file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      alert('File size must be less than 10MB');
      this.clearFileSelection();
      return;
    }

    // Hide upload area and show preview
    if (uploadArea) uploadArea.style.display = 'none';
    if (filePreviewArea) filePreviewArea.style.display = 'block';

    // Update file info
    if (fileName) fileName.textContent = file.name;
    if (fileSize) fileSize.textContent = `${(file.size / 1024 / 1024).toFixed(2)}MB`;

    // Show image preview for image files
    if (file.type.startsWith('image/') && imagePreview) {
      const reader = new FileReader();
      reader.onload = (e) => {
        imagePreview.src = e.target.result;
        imagePreview.style.display = 'block';
      };
      reader.readAsDataURL(file);
    } else {
      // Hide image preview for non-image files
      if (imagePreview) imagePreview.style.display = 'none';
    }

    console.log('File selected:', file.name, file.type, file.size);
  }

  clearFileSelection() {
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    const uploadArea = document.querySelector('div[id^="uploadArea-"]');
    const imagePreview = document.querySelector('img[id^="imagePreview-"]');
    const filePreviewArea = document.querySelector('div[id^="filePreviewArea-"]');

    // Clear the file input
    if (fileInput) fileInput.value = '';

    // Show upload area and hide preview
    if (uploadArea) uploadArea.style.display = 'block';
    if (filePreviewArea) filePreviewArea.style.display = 'none';
    if (imagePreview) imagePreview.style.display = 'none';

    console.log('File selection cleared');
  }
  
  updatePrintTypeAvailability() {
    const fullColourBtn = document.getElementById('full-colour-print-btn');
    const unavailableIndicator = fullColourBtn?.querySelector('.unavailable-indicator');
    
    if (fullColourBtn && unavailableIndicator) {
      const isAvailable = this.fullColourSizes.includes(this.selectedSize);
      
      if (isAvailable) {
        fullColourBtn.classList.remove('disabled');
        unavailableIndicator.style.display = 'none';
      } else {
        fullColourBtn.classList.add('disabled');
        unavailableIndicator.style.display = 'inline';
        
        // Switch to Simple Print if Full Colour was selected
        if (this.selectedPrintType === 'FullColour') {
          const simplePrintBtn = document.getElementById('simple-print-btn');
          if (simplePrintBtn) {
            simplePrintBtn.click();
    }
        }
      }
    }
  }
  
  getPricingKey() {
    const printType = this.selectedPrintType === 'FullColour' ? 'FullColour' : 'Simple';
    return `${this.selectedSize}_${printType}`;
  }

  // Helper function to get the appropriate lid quantity based on cup quantity
  getLidQuantityTier(cupQuantity) {
    // Map cup quantities to lid variant quantities
    if (cupQuantity <= 250) return "250";
    if (cupQuantity <= 500) return "500"; 
    if (cupQuantity <= 1000) return "1000";
    if (cupQuantity <= 2000) return "2000";
    if (cupQuantity <= 3000) return "3000";
    if (cupQuantity <= 4000) return "4000";
    if (cupQuantity <= 5000) return "5000";
    if (cupQuantity >= 10000) return "10000";
    return "5000"; // Default fallback
    }

  async updatePricingTable() {
    const tbody = document.getElementById('quantity-grid-body');
    if (!tbody) return;

    try {
      // Load product data and find variants
      await this.loadProductData();
      
      if (!this.productData) {
        console.warn('No product data available, using fallback pricing');
        this.updatePricingTableWithFallback();
        return;
      }

      const pricingKey = this.getPricingKey();
      const variantMappings = this.variantMapping[pricingKey];
      
      if (!variantMappings) {
        console.warn(`No variant mapping found for ${pricingKey}, using fallback`);
        this.updatePricingTableWithFallback();
        return;
      }

      console.log('Updating pricing for:', pricingKey);

      tbody.innerHTML = '';

      // Create rows for each quantity tier
      const quantities = Object.keys(variantMappings).map(q => parseInt(q)).sort((a, b) => a - b);
      
      quantities.forEach((quantity, index) => {
        const variantId = variantMappings[quantity.toString()];
        const variant = this.productData.variants.find(v => v.id.toString() === variantId);
        
        let unitPrice;
        if (variant) {
          // Convert price from cents or keep as decimal based on Shopify format
          const variantTotalPrice = typeof variant.price === 'string' ? 
            parseFloat(variant.price) : 
            variant.price / 100;
          // Calculate unit price by dividing total variant price by quantity
          unitPrice = variantTotalPrice / quantity;
        } else {
          console.warn(`Variant ${variantId} not found for ${quantity} quantity, using fallback`);
          unitPrice = this.getFallbackPrice(quantity, pricingKey);
        }

        // Store unit price for this quantity
        this.unitPricesByQuantity[quantity] = unitPrice;

        // Store current unit price for calculations
        if (quantity === this.selectedQuantity) {
          this.currentUnitPrice = unitPrice;
        }

        const row = document.createElement('tr');
        row.classList.add('quantity-row');
        row.dataset.quantity = quantity;
        
        // Make entire row clickable
        row.addEventListener('click', () => {
          const radio = row.querySelector('input[type="radio"]');
          if (radio) {
            radio.checked = true;
            this.selectedQuantity = quantity;
            this.currentUnitPrice = this.unitPricesByQuantity[quantity]; // Update unit price
            this.updateRowSelection();
            this.updateSelectedQuantityDisplay();
            this.updateOrderSummary();
          }
        });
        
        // Radio button
        const radioCell = document.createElement('td');
        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'quantity_selection';
        radio.value = quantity;
        radio.addEventListener('change', () => {
          if (radio.checked) {
            this.selectedQuantity = quantity;
            this.currentUnitPrice = this.unitPricesByQuantity[quantity]; // Update unit price
            this.updateRowSelection();
            this.updateSelectedQuantityDisplay();
            this.updateOrderSummary();
          }
        });
        radioCell.appendChild(radio);
        row.appendChild(radioCell);
        
        // Pre-select first option or maintain current selection
        if ((index === 0 && this.selectedQuantity === null) || quantity === this.selectedQuantity) {
          radio.checked = true;
          this.selectedQuantity = quantity;
          row.classList.add('selected');
        }
        
        // Quantity
        const qtyCell = document.createElement('td');
        qtyCell.textContent = quantity.toLocaleString();
        row.appendChild(qtyCell);

        // Cartons
        const cartonsCell = document.createElement('td');
        const cartons = quantity / this.UNITS_PER_CARTON[this.selectedSize];
        cartonsCell.textContent = this.formatNumber(cartons);
        row.appendChild(cartonsCell);
        
        // Unit Price with membership pricing
        const unitCell = document.createElement('td');
        
        // Check for membership pricing
        const customerTags = document.body.dataset.customerTags || '';
        const tags = customerTags.toLowerCase().split(',').map(tag => tag.trim());
        let memberTier = null;
        let discountPercent = 0;
        
        if (window.MembershipPricing) {
          memberTier = window.MembershipPricing.getCustomerTier();
          discountPercent = window.MembershipPricing.getDiscountPercent();
        } else {
          // Fallback to legacy logic for bronze/silver/gold/trade
          if (tags.includes('trade')) {
            memberTier = 'trade';
            discountPercent = 20;
          } else if (tags.includes('gold')) {
            memberTier = 'gold';
            discountPercent = 15;
          } else if (tags.includes('silver')) {
            memberTier = 'silver';
            discountPercent = 10;
          } else if (tags.includes('bronze')) {
            memberTier = 'bronze';
            discountPercent = 5;
          }
        }
        
        if (memberTier && discountPercent > 0) {
          const discountedUnitPrice = unitPrice * (1 - discountPercent / 100);
          console.log(`[Membership Debug] Unit Price - Original: $${unitPrice.toFixed(2)}, Discounted: $${discountedUnitPrice.toFixed(2)}, Tier: ${memberTier}`);
          
          unitCell.innerHTML = `
            <span class="original-price">$${unitPrice.toFixed(2)}</span>
            <span class="member-price member-${memberTier}">$${discountedUnitPrice.toFixed(2)}</span>
            <span class="membership-badge membership-${memberTier}">${memberTier === 'trade' ? '💎' : memberTier === 'gold' ? '🥇' : memberTier === 'silver' ? '🥈' : '🥉'}</span>
          `;
        } else {
          unitCell.textContent = `$${unitPrice.toFixed(2)}`;
        }
        row.appendChild(unitCell);
        
        // Total Price with membership discount (base only, no lids or rush)
        const totalCell = document.createElement('td');
        let baseTotal = quantity * unitPrice;
        
        if (memberTier && discountPercent > 0) {
          const discountedTotal = baseTotal * (1 - discountPercent / 100);
          totalCell.innerHTML = `
            <span class="original-price">$${baseTotal.toFixed(2)}</span>
            <span class="member-price member-${memberTier}">$${discountedTotal.toFixed(2)}</span>
          `;
        } else {
          totalCell.textContent = `$${baseTotal.toFixed(2)}`;
        }
        row.appendChild(totalCell);
        
        tbody.appendChild(row);
      });
      
      this.updateRowSelection();
      this.updateSelectedQuantityDisplay();
      this.updateOrderSummary();

    } catch (error) {
      console.error('Error updating pricing table:', error);
      this.updatePricingTableWithFallback();
    }
  }

  updatePricingTableWithFallback() {
    const tbody = document.getElementById('quantity-grid-body');
    if (!tbody) return;

    const pricingKey = this.getPricingKey();
    const variantMappings = this.variantMapping[pricingKey];
    
    if (!variantMappings) {
      tbody.innerHTML = '<tr><td colspan="5" style="text-align: center; padding: 2em;">No pricing available for this configuration</td></tr>';
      return;
    }

    tbody.innerHTML = '';

    const quantities = Object.keys(variantMappings).map(q => parseInt(q)).sort((a, b) => a - b);
    
    quantities.forEach((quantity, index) => {
      const unitPrice = this.getFallbackPrice(quantity, pricingKey);

      // Store current unit price for calculations
      if (quantity === this.selectedQuantity) {
        this.currentUnitPrice = unitPrice;
      }

      const row = document.createElement('tr');
      row.classList.add('quantity-row');
      row.dataset.quantity = quantity;
      
      // Make entire row clickable
      row.addEventListener('click', () => {
        const radio = row.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          this.selectedQuantity = quantity;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateOrderSummary();
        }
      });
      
      // Radio button
      const radioCell = document.createElement('td');
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'quantity_selection';
      radio.value = quantity;
      radio.addEventListener('change', () => {
        if (radio.checked) {
          this.selectedQuantity = quantity;
          this.updateRowSelection();
          this.updateSelectedQuantityDisplay();
          this.updateOrderSummary();
        }
      });
      radioCell.appendChild(radio);
      row.appendChild(radioCell);
      
      // Pre-select first option or maintain current selection
      if ((index === 0 && this.selectedQuantity === null) || quantity === this.selectedQuantity) {
        radio.checked = true;
        this.selectedQuantity = quantity;
        row.classList.add('selected');
      }
      
      // Quantity
      const qtyCell = document.createElement('td');
      qtyCell.textContent = quantity.toLocaleString();
      row.appendChild(qtyCell);

      // Cartons
      const cartonsCell = document.createElement('td');
      const cartons = quantity / this.UNITS_PER_CARTON[this.selectedSize];
      cartonsCell.textContent = this.formatNumber(cartons);
      row.appendChild(cartonsCell);
      
      // Unit Price (format as currency)
      const unitCell = document.createElement('td');
      unitCell.textContent = `$${unitPrice.toFixed(2)}`;
      row.appendChild(unitCell);
      
      // Total Price (base only, no lids or rush)
      const totalCell = document.createElement('td');
      let baseTotal = quantity * unitPrice;
      totalCell.textContent = `$${baseTotal.toFixed(2)}`;
      row.appendChild(totalCell);
      
      tbody.appendChild(row);
    });
    
    this.updateRowSelection();
    this.updateSelectedQuantityDisplay();
    this.updateOrderSummary();
  }

  getFallbackPrice(quantity, pricingKey) {
    // Ice cream cup fallback pricing based on size
    const basePrices = {
      '2oz_Simple': {
        250: 1.680, 500: 1.083, 1000: 0.758, 2000: 0.538, 3000: 0.464, 4000: 0.427, 5000: 0.405
      },
      '3oz_Simple': {
        250: 1.700, 500: 1.100, 1000: 0.775, 2000: 0.554, 3000: 0.481, 4000: 0.444, 5000: 0.422
      },
      '5oz_Simple': {
        250: 1.728, 500: 1.117, 1000: 0.792, 2000: 0.571, 3000: 0.497, 4000: 0.460, 5000: 0.438
      },
      '11oz_Simple': {
        250: 1.450, 500: 0.950, 1000: 0.650, 2000: 0.430, 3000: 0.390, 4000: 0.370, 5000: 0.320
      }
    };

    const priceData = basePrices[pricingKey];
    return priceData?.[quantity] || 0.50; // Default fallback price
  }

  updateRowSelection() {
    // Remove selection from all rows
    document.querySelectorAll('.quantity-row').forEach(row => {
      row.classList.remove('selected');
    });
    
    // Add selection to current row
    if (this.selectedQuantity) {
      const selectedRow = document.querySelector(`[data-quantity="${this.selectedQuantity}"]`);
      if (selectedRow) {
        selectedRow.classList.add('selected');
      }
    }
  }
  
  updateSelectedQuantityDisplay() {
    // Update any selected quantity display elements
    const selectedQtyElements = document.querySelectorAll('.selected-quantity-display');
    selectedQtyElements.forEach(el => {
      el.textContent = this.selectedQuantity ? this.selectedQuantity.toLocaleString() : '';
    });
    
    // Update order summary
    this.updateOrderSummary();
  }
  
  updateOrderSummary() {
    if (!this.selectedQuantity) return;
    
    // Use cached unit price from live pricing or fallback
    let unitPrice = this.currentUnitPrice || this.calculateUnitPrice();
    let lidPrice = 0;
    let rushFee = 0;

    // Determine membership tier/percent
    let memberTier = null;
    let memberDiscountPercent = 0;
    if (window.MembershipPricing) {
      memberTier = window.MembershipPricing.getCustomerTier();
      memberDiscountPercent = window.MembershipPricing.getDiscountPercent();
    } else {
      const tags = (document.body.dataset.customerTags || '').toLowerCase().split(',').map(t=>t.trim());
      if (tags.includes('trade')) { memberTier = 'trade'; memberDiscountPercent = 20; }
      else if (tags.includes('gold')) { memberTier = 'gold'; memberDiscountPercent = 15; }
      else if (tags.includes('silver')) { memberTier = 'silver'; memberDiscountPercent = 10; }
      else if (tags.includes('bronze')) { memberTier = 'bronze'; memberDiscountPercent = 5; }
    }

    // Calculate cup total and apply member discount
    let cupTotal = this.selectedQuantity * unitPrice;
    if (memberDiscountPercent > 0) {
      cupTotal = cupTotal * (1 - memberDiscountPercent / 100);
    }
    let totalPrice = cupTotal;

    // Add lids cost (for display purposes)
    if (this.requireLids) {
      // Check if we're using lid-inclusive pricing (8oz 10,000 quantity)
      const useLidInclusiveVariant = (this.selectedQuantity === 10000 && this.selectedSize === '8oz');
      
      if (useLidInclusiveVariant) {
        // Lids are included in the unit price, so no separate lid cost
        lidPrice = 0;
        document.getElementById('summary-lid-row').style.display = 'none';
        document.getElementById('summary-lid-price').textContent = '$0.00';
      } else {
        // Calculate separate lid pricing and apply member discount in summary
        const lidUnitPrice = this.selectedQuantity >= 1000 ? this.LID_PRICE_HIGH_QTY : this.LID_PRICE_LOW_QTY;
        const originalLidPrice = this.selectedQuantity * lidUnitPrice;
        lidPrice = originalLidPrice;
        if (memberDiscountPercent > 0) {
          lidPrice = originalLidPrice * (1 - memberDiscountPercent / 100);
        }
        totalPrice += lidPrice;
        unitPrice += lidUnitPrice;
        document.getElementById('summary-lid-row').style.display = '';
        if (memberDiscountPercent > 0 && memberTier) {
          document.getElementById('summary-lid-price').innerHTML = `
            <span class="original-price">$${originalLidPrice.toFixed(2)}</span>
            <span class="member-price member-${memberTier}">$${lidPrice.toFixed(2)}</span>
          `;
        } else {
          document.getElementById('summary-lid-price').textContent = `$${lidPrice.toFixed(2)}`;
        }
      }
    } else {
      document.getElementById('summary-lid-row').style.display = 'none';
      document.getElementById('summary-lid-price').textContent = '$0.00';
    }

    // Add rush surcharge (for display purposes)
    if (this.isRushed) {
      // Calculate rush on discounted cup total for members
      let baseCupTotal = this.selectedQuantity * this.calculateUnitPrice();
      const productionFeeMultiplier = this.getProductionFeeMultiplier();
      if (memberDiscountPercent > 0) {
        baseCupTotal = baseCupTotal * (1 - memberDiscountPercent / 100);
        rushFee = baseCupTotal * productionFeeMultiplier;
        document.getElementById('summary-rush-row').style.display = '';
        const originalCupTotal = this.selectedQuantity * this.calculateUnitPrice();
        const originalRush = Math.round(originalCupTotal * productionFeeMultiplier);
        document.getElementById('summary-rush-fee').innerHTML = `
          <span class="original-price">$${originalRush.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${rushFee.toFixed(2)}</span>
        `;
      } else {
        rushFee = Math.round(baseCupTotal * productionFeeMultiplier);
        document.getElementById('summary-rush-row').style.display = '';
        document.getElementById('summary-rush-fee').textContent = `$${rushFee.toFixed(2)}`;
      }
      totalPrice += rushFee;
    } else {
      document.getElementById('summary-rush-row').style.display = 'none';
      document.getElementById('summary-rush-fee').textContent = '$0.00';
      }

    // Update summary elements
    const summaryQuantity = document.getElementById('summary-quantity');
    const summaryUnitPrice = document.getElementById('summary-unit-price');
    const summaryTotal = document.getElementById('summary-total');
    
    if (summaryQuantity) summaryQuantity.textContent = this.selectedQuantity.toLocaleString();
    if (summaryUnitPrice) {
      if (memberTier && memberDiscountPercent > 0) {
        const discountedUnitPrice = unitPrice * (1 - memberDiscountPercent / 100);
        summaryUnitPrice.innerHTML = `
          <span class="original-price">$${unitPrice.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${discountedUnitPrice.toFixed(2)}</span>
        `;
      } else {
        summaryUnitPrice.textContent = `$${unitPrice.toFixed(2)}`;
      }
    }

    if (summaryTotal) {
      if (memberTier && memberDiscountPercent > 0) {
        const originalCupTotal = this.selectedQuantity * this.calculateUnitPrice();
        const originalLidPrice = this.requireLids ? this.selectedQuantity * (this.selectedQuantity >= 1000 ? this.LID_PRICE_HIGH_QTY : this.LID_PRICE_LOW_QTY) : 0;
        const originalRush = this.isRushed ? Math.round(originalCupTotal * this.getProductionFeeMultiplier()) : 0;
        const originalTotal = originalCupTotal + originalLidPrice + originalRush;
        summaryTotal.innerHTML = `
          <span class="original-price">$${originalTotal.toFixed(2)}</span>
          <span class="member-price member-${memberTier}">$${totalPrice.toFixed(2)}</span>
        `;
      } else {
        summaryTotal.textContent = `$${totalPrice.toFixed(2)}`;
      }
    }
  }

  async addToCart() {
    const button = document.getElementById('custom-add-to-cart-btn');
    if (!button) return;

    // Validate that a design file is uploaded
    const fileInput = document.querySelector('input[type="file"][name="properties[Design File]"]');
    // File upload is now optional, so skip this check

    // Show loading state
    button.classList.add('loading');
    button.disabled = true;

    try {
      // Get the correct variant ID based on size, print type, and quantity
      const pricingKey = this.getPricingKey();
      const quantityKey = String(this.selectedQuantity);
      
      // Check if we should use lid-inclusive variant (10,000 quantity + 8oz + lids selected)
      let variantId;
      let useLidInclusiveVariant = false;
      
      if (this.requireLids && this.selectedQuantity === 10000 && this.selectedSize === '8oz') {
        // For 8oz 10,000 quantity with lids, use the lid-inclusive variant
        const lidQuantityTier = this.getLidQuantityTier(this.selectedQuantity);
        const lidVariantId = this.lidVariantMapping[this.lidColor]?.[lidQuantityTier];
        
        if (lidVariantId) {
          variantId = lidVariantId;
          useLidInclusiveVariant = true;
          console.log('[AddToCart Debug] Using lid-inclusive variant for 8oz 10000:', variantId);
        } else {
          // Fallback to regular variant if lid variant not found
          variantId = this.variantMapping[pricingKey]?.[quantityKey];
        }
      } else {
        // Use regular variant
        variantId = this.variantMapping[pricingKey]?.[quantityKey];
      }
      
      console.log('[AddToCart Debug] Selected variant ID:', variantId);
      
      if (!variantId) {
        throw new Error(`No variant found for ${pricingKey} - ${quantityKey} units.`);
      }

      // Create FormData to handle file upload
      const formData = new FormData();

      // Shared group id so the cup, its lids and its rush fee stay linked in the cart
      // (cart grouping + add-on panel + rush removal all key off _epk_group). Without this
      // the rush fee renders as a separate, unlinked card.
      const epkGroup = 'epkorder-' + Date.now().toString(36) + '-' + Math.floor(Math.random() * 1000000).toString(36);

      // Add the main cup variant (or lid-inclusive variant)
      formData.append('items[0][id]', variantId);
      formData.append('items[0][quantity]', '1');
      formData.append('items[0][properties][Size]', this.selectedSize);
      formData.append('items[0][properties][Print Type]', this.selectedPrintType);
      formData.append('items[0][properties][Quantity]', this.selectedQuantity);
      formData.append('items[0][properties][Price/Unit]', `$${this.calculateUnitPrice().toFixed(2)}`);
      formData.append('items[0][properties][Production Time]', this.getProductionTimePropertyValue());
      formData.append('items[0][properties][_epk_group]', epkGroup);

      if (useLidInclusiveVariant) {
        formData.append('items[0][properties][Includes Lids]', `${this.lidColor} lids included`);
      }
      
      // Add the uploaded file
      if (fileInput.files[0]) {
        formData.append('items[0][properties][Design File]', fileInput.files[0]);
      }

      let itemIndex = 1; // Start next items at index 1

      // Add separate lid variant if lids are required AND we didn't use lid-inclusive variant
      if (this.requireLids && !useLidInclusiveVariant) {
        const lidQuantityTier = this.getLidQuantityTier(this.selectedQuantity);
        const lidVariantId = this.lidVariantMapping[this.lidColor]?.[lidQuantityTier];
        
        if (lidVariantId) {
          formData.append(`items[${itemIndex}][id]`, lidVariantId);
          formData.append(`items[${itemIndex}][quantity]`, '1');
          formData.append(`items[${itemIndex}][properties][Type]`, 'Lids');
          formData.append(`items[${itemIndex}][properties][Color]`, this.lidColor);
          formData.append(`items[${itemIndex}][properties][Quantity]`, String(this.selectedQuantity));
          formData.append(`items[${itemIndex}][properties][For Cup Size]`, this.selectedSize);
          formData.append(`items[${itemIndex}][properties][_epk_group]`, epkGroup);
          itemIndex++;
        }
      }

      // Add rush fee as separate product if rushed is selected
      if (this.isRushed) {
        const variantTotalPrice = this.calculateVariantTotalPrice();
        const productionFeePercent = this.getProductionFeePercent();
        const rushFeeAmount = variantTotalPrice * (productionFeePercent / 100);
        const rushFeeQuantity = Math.round(rushFeeAmount);
        
        formData.append(`items[${itemIndex}][id]`, '50675778126106');
        formData.append(`items[${itemIndex}][quantity]`, rushFeeQuantity);
        formData.append(`items[${itemIndex}][properties][Base Order Total]`, `$${variantTotalPrice.toFixed(2)}`);
        formData.append(`items[${itemIndex}][properties][Production Time]`, this.getProductionTimeLabel());
        formData.append(`items[${itemIndex}][properties][Production Fee (${this.getProductionTimeLabel()}) +${productionFeePercent}%]`, `$${rushFeeAmount.toFixed(2)}`);
        formData.append(`items[${itemIndex}][properties][_epk_group]`, epkGroup);
      }

      // Submit to cart using FormData (supports file uploads)
      const response = await fetch('/cart/add', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to add to cart: ${response.status} - ${errorText}`);
      }

      // Success
      document.dispatchEvent(new CustomEvent('cart:updated'));
      // Set flag for success state after page refresh
      localStorage.setItem('cartAddSuccess', 'true');
      // Reload page to update cart UI (since we're using form submission)
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (error) {
      console.error('Cart error:', error);
      this.showMessage(`Error adding to cart: ${error.message}`, 'error');
    } finally {
      button.classList.remove('loading');
      button.disabled = false;
    }
  }
  
  // Helper method to calculate unit price
  calculateUnitPrice() {
    // Use cached unit price from live pricing if available
    if (this.currentUnitPrice) {
      return this.currentUnitPrice;
    }
    
    // Fallback to calculating from fallback pricing
    const pricingKey = this.getPricingKey();
    return this.getFallbackPrice(this.selectedQuantity, pricingKey);
  }

  // Helper method to calculate variant total price
  calculateVariantTotalPrice() {
    // Calculate total price dynamically based on current pricing data
    const unitPrice = this.calculateUnitPrice();
    const totalPrice = unitPrice * this.selectedQuantity;
    
    console.log(`[VariantTotalPrice] Unit: $${unitPrice}, Qty: ${this.selectedQuantity}, Total: $${totalPrice}`);
    
    return totalPrice;
  }

  // Smart number formatting - only show decimals if needed, max 2 decimals
  formatNumber(number) {
    const rounded = Math.round(number * 100) / 100; // Round to 2 decimals
    return rounded % 1 === 0 ? rounded.toString() : rounded.toFixed(2);
  }
  
  showMessage(text, type) {
    console.log('showMessage called:', text, type);
    
    // Remove existing messages
    const existingMessages = document.querySelectorAll('.cup-message');
    existingMessages.forEach(msg => msg.remove());
    
    // Create new toast message
    const message = document.createElement('div');
    message.className = `cup-message cup-${type}-message cup-toast-message`;
    message.textContent = text;
    
    // Position the toast near the Add to cart button
    const addToCartButton = document.querySelector('#custom-add-to-cart-btn') || 
                           document.querySelector('.custom-add-to-cart-button') ||
                           document.querySelector('.product-form-cup__cart-submit') || 
                           document.querySelector('#product-form-cup button[type="submit"]') ||
                           document.querySelector('button[name="add"]');
    
    console.log('Found button:', addToCartButton);
    
    if (addToCartButton) {
      const buttonRect = addToCartButton.getBoundingClientRect();
      console.log('Button rect:', buttonRect);
      
      // Position the toast near the button
      message.style.position = 'fixed';
      message.style.top = `${buttonRect.top + (buttonRect.height / 2) - 30}px`;
      message.style.right = '20px';
      message.style.zIndex = '9999';
      
      document.body.appendChild(message);
      console.log('Toast appended to body');
      
      // Trigger slide-in animation
      setTimeout(() => {
        message.classList.add('show');
        console.log('Toast show class added');
      }, 10);
      
      // Auto-remove after 3 seconds
      setTimeout(() => {
        message.classList.add('hide');
      setTimeout(() => {
        message.remove();
          console.log('Toast removed');
        }, 300); // Allow fade-out animation to complete
      }, 3000);
    } else {
      console.warn('Add to cart button not found, falling back to simple display');
      // Fallback: just append to body with default positioning
      message.style.position = 'fixed';
      message.style.top = '20px';
      message.style.right = '20px';
      message.style.zIndex = '9999';
      
      document.body.appendChild(message);
      
      setTimeout(() => {
        message.classList.add('show');
      }, 10);
      
      setTimeout(() => {
        message.classList.add('hide');
        setTimeout(() => {
          message.remove();
        }, 300);
      }, 3000);
    }
  }
  
  // Helper function to convert decimal to fraction
  decimalToFraction(decimal) {
    if (decimal >= 1) {
      return Math.floor(decimal).toString();
    }
    
    // Common fractions for carton sizes
    const fractions = {
      0.25: '1/4',
      0.5: '1/2',
      0.75: '3/4'
    };
    
    return fractions[decimal] || decimal.toString();
    }

  updateMediaGalleryForSelectedVariant() {
    // Get the correct variant ID based on current selections
    const pricingKey = this.getPricingKey();
    const quantityKey = String(this.selectedQuantity);
    const variantId = this.variantMapping[pricingKey]?.[quantityKey];
    
    if (!variantId) {
      console.log('No variant ID found for:', pricingKey, quantityKey);
      return;
    }

    console.log('Updating for variant ID:', variantId);
    
    // Update variant ID input
    const variantIdInputs = document.querySelectorAll('input[name="id"]');
    variantIdInputs.forEach(input => {
      input.value = variantId;
      console.log('Updated variant input to:', variantId);
    });

    // Update URL
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', currentUrl.toString());
    console.log('Updated URL variant to:', variantId);
    
    // Find the variant's featured media and switch to it
    this.switchToVariantMedia(variantId);
    
    // Trigger a change event on the variant input to let Shopify know
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  
  switchToVariantMedia(variantId) {
    try {
      // Get product data
      const productScript = document.querySelector(`script[id^="ProductJSON-"]`);
      if (!productScript) {
        console.log('No product data script found');
        return;
      }
      
      const productData = JSON.parse(productScript.textContent);
      const variant = productData.variants?.find(v => v.id == variantId);
      
      if (!variant || !variant.featured_media?.id) {
        console.log('No variant or featured media found for:', variantId);
        return;
      }
      
      console.log('Switching to media ID:', variant.featured_media.id, 'for variant:', variant.title);
      
      // Find the media gallery component
      const mediaGallery = document.querySelector('media-gallery');
      if (!mediaGallery) {
        console.log('Media gallery component not found');
        return;
      }
      
      // Get the section ID from the media gallery
      const sectionId = mediaGallery.dataset.sectionId;
      const targetMediaId = `${sectionId}-${variant.featured_media.id}`;
      
      console.log('Looking for media with ID:', targetMediaId);
      
      // Find the thumbnail with the matching data-target
      const thumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (thumbnail) {
        const button = thumbnail.querySelector('button');
        if (button) {
          console.log('Found thumbnail button, clicking it');
          button.click();
          return;
        }
      }
      
      // Fallback: directly call setActiveMedia if thumbnail click didn't work
      console.log('Thumbnail not found, using direct media switching');
      if (mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(targetMediaId, false);
      } else {
        // Manual fallback
        this.manualMediaSwitch(targetMediaId);
      }
      
    } catch (error) {
      console.error('Error switching variant media:', error);
    }
  }
  
  manualMediaSwitch(targetMediaId) {
    console.log('Manual media switch to:', targetMediaId);
    
    // Remove active from all media items
    const allMediaItems = document.querySelectorAll('.product__media-item');
    allMediaItems.forEach(item => {
      item.classList.remove('is-active');
    });
    
    // Add active to target media item
    const targetMediaItem = document.querySelector(`[data-media-id="${targetMediaId}"]`);
    if (targetMediaItem) {
      targetMediaItem.classList.add('is-active');
      console.log('Manually activated media item:', targetMediaId);
      
      // Also update thumbnails
      const allThumbnails = document.querySelectorAll('[data-target] button');
      allThumbnails.forEach(btn => {
        btn.removeAttribute('aria-current');
        btn.parentElement.classList.remove('is-active');
      });
      
      const targetThumbnail = document.querySelector(`[data-target="${targetMediaId}"]`);
      if (targetThumbnail) {
        const button = targetThumbnail.querySelector('button');
        if (button) {
          button.setAttribute('aria-current', 'true');
          targetThumbnail.classList.add('is-active');
        }
      }
    } else {
      console.log('Target media item not found:', targetMediaId);
    }
  }

  checkCartAddSuccess() {
    const successFlag = localStorage.getItem('cartAddSuccess');
    if (successFlag === 'true') {
      localStorage.removeItem('cartAddSuccess');
      this.showMessage('Added to cart successfully!', 'success');
    }
  }

  preventAutoScroll() {
    // More comprehensive scroll prevention following ChatGPT recommendation
    
    // 1. Override scrollIntoView temporarily during variant changes
    const originalScrollIntoView = Element.prototype.scrollIntoView;
    let preventScrolling = false;
    
    const blockScrollIntoView = () => {
      preventScrolling = true;
      Element.prototype.scrollIntoView = () => {}; // Block all scrollIntoView calls
      
      // Re-enable after a short delay
      setTimeout(() => {
        Element.prototype.scrollIntoView = originalScrollIntoView;
        preventScrolling = false;
      }, 500);
    };
    
    // 2. Prevent scroll on variant option changes (universal fix)
    document.querySelectorAll('[name="options"] select, [name="options"] input').forEach(el => {
      el.addEventListener('change', (e) => {
        blockScrollIntoView();
        
        // Prevent URL-based auto-scroll
        const url = new URL(window.location);
        url.searchParams.set(el.name, el.value);
        history.replaceState({}, '', url);
      });
    });
    
    // 3. Prevent scroll on our custom buttons
    const buttons = document.querySelectorAll('.size-btn, .print-type-btn, .lids-pill, .production-slider-mark');
    buttons.forEach(button => {
      button.addEventListener('click', (e) => {
        blockScrollIntoView();
        // Don't prevent default here as it would break functionality
      });
    });
    
    // 4. Intercept variant form changes
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      variantSelects.addEventListener('change', () => {
        blockScrollIntoView();
      });
    }
  }
}

// Smooth scroll to shipping calculator function
function scrollToShippingCalculator(event) {
  event.preventDefault();
  
  const shippingCalculator = document.getElementById('shipping-calculator');
  if (shippingCalculator) {
    shippingCalculator.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Smooth scroll to ETA calculator section function
function scrollToEtaCalculator(event) {
  event.preventDefault();
  
  const etaCalculatorSection = document.getElementById('eta-calculator-section');
  if (etaCalculatorSection) {
    etaCalculatorSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Legacy function for backwards compatibility
function scrollToDesignUpload(event) {
  event.preventDefault();
  
  const shippingCalculator = document.getElementById('shipping-calculator');
  if (shippingCalculator) {
    shippingCalculator.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

function scrollToShippingCalculator(event) {
  event.preventDefault();
  
  const shippingCalculator = document.getElementById('shipping-calculator');
  if (shippingCalculator) {
    shippingCalculator.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}

// Test function for toast notification
function testToast() {
  if (window.coffeeCupProduct) {
    window.coffeeCupProduct.showMessage('Test toast message!', 'success');
  } else {
    console.error('CoffeeCupProduct not found');
  }
}

// Force bold function for dropdown titles
function forceBoldTitles() {
  console.log('Running forceBoldTitles...');
  
  // Find all dropdown titles
  const allTitles = document.querySelectorAll('.dropdown-title, .description-title');
  console.log('Found titles:', allTitles.length);
  
  allTitles.forEach((title, index) => {
    console.log(`Making title bold: ${title.textContent.trim()}`);
    
    // Use regular bold font-weight without text-shadow
    title.style.setProperty('font-weight', 'bold', 'important');
    title.classList.add('force-bold');
  });
  
  // NOW MAKE VARIANT SELECTOR TITLES BLACK
  const variantLabels = document.querySelectorAll('.form__label');
  console.log('Found variant labels:', variantLabels.length);
  
  variantLabels.forEach((label, index) => {
    console.log(`Making variant label black: ${label.textContent.trim()}`);
    label.style.setProperty('color', '#000000', 'important');
    label.style.setProperty('font-weight', 'bold', 'important');
  });
  
  // MAKE MAIN PRODUCT TITLE BLACK
  const mainProductTitle = document.querySelector('.product__title h1');
  if (mainProductTitle) {
    console.log(`Making main product title black: ${mainProductTitle.textContent.trim()}`);
    mainProductTitle.style.setProperty('color', '#000000', 'important');
  }
  
  // MAKE PRODUCT TAGLINE BLACK
  const productTagline = document.querySelector('.product-tagline');
  if (productTagline) {
    console.log(`Making product tagline black: ${productTagline.textContent.trim()}`);
    productTagline.style.setProperty('color', '#000000', 'important');
  }
  
  // Add CSS rule if it doesn't exist
  if (!document.querySelector('#force-bold-style')) {
    const style = document.createElement('style');
    style.id = 'force-bold-style';
    style.textContent = `
      .force-bold, .dropdown-title, .description-title {
        font-weight: 700 !important;
      }
      .form__label {
        color: #000000 !important;
        font-weight: bold !important;
      }
      .product__title h1 {
        color: #000000 !important;
      }
      .product-tagline {
        color: #000000 !important;
      }
    `;
    document.head.appendChild(style);
    console.log('Added force-bold CSS rule');
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const pricingTable = document.getElementById('quantity-grid-body');
  const sizeButtons = document.querySelectorAll('.size-btn');
  
  if (pricingTable && sizeButtons.length > 0) {
    new CoffeeCupProduct();
  }
});
